import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "prev-arrow",
  "use": "prev-arrow-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\" fill=\"#fff\" id=\"prev-arrow\"><path d=\"M27.3,48.4L70.6,5c0.6-0.6,1.6-0.6,2.1,0s0.6,1.6,0,2.1L30.4,49.6L72.8,92c0.6,0.6,0.6,1.6,0,2.1\tc-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.1-1.1-0.4L27.3,50.8c-0.3-0.3-0.5-0.8-0.5-1.2C26.7,49.1,26.9,48.7,27.3,48.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol